import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import {
  getKey,
  convertRupeeCharToUnicode,
  areObjectValuesShallowNotEqual,
  money,
  staticPath
} from '../../../utils/common';

import { locale } from '../../../utils/i18n';

class PaymodeOffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      offerMessage: null
    };
  }

  componentDidMount() {
    this.updateState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateState(nextProps);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      areObjectValuesShallowNotEqual(this.props, nextProps, [
        'offer',
        'applied',
        'shouldHighlightOfferError'
      ]) || areObjectValuesShallowNotEqual(this.state, nextState, Object.keys(this.state))
    );
  }

  updateState({ offer }) {
    const errorMessage = getKey(offer, 'validationErrorMessage');
    let offerMessage = '';

    if (!errorMessage) {
      const instantDiscount = getKey(offer, 'instantDiscount');
      const cashbackAmount = getKey(offer, 'cashbackAmount');
      const isOfferAvailable = Boolean(instantDiscount || cashbackAmount);

      if (isOfferAvailable) {
        offerMessage = instantDiscount
          ? locale('offers.instantDiscount').replace('amount', money(instantDiscount))
          : locale('offers.cashback').replace('amount', money(cashbackAmount));
        offerMessage = convertRupeeCharToUnicode(offerMessage);
      }
    }
    this.setState({
      errorMessage,
      offerMessage
    });
  }

  render(
    { shouldHighlightOfferError, applied = true, noLeftPadding = false },
    { offerMessage, errorMessage }
  ) {
    return (
      <div className={`ptm-cash-app ptm-body-color ${noLeftPadding ? 'ptm-mg-lt-0' : ''}`}>
        {offerMessage && (
          <span class={`ptm-message`}>
            {applied && (
              <img
                class={`ptm-offer-applied-img`}
                src={`${staticPath()}/assets/images/ic-selection.svg`}
                alt="offer-applied-img"
              />
            )}
            {offerMessage}
          </span>
        )}
        {applied && errorMessage && (
          <div className={`${shouldHighlightOfferError ? 'ptm-highlight' : ''} ptm-error`}>
            {errorMessage}
          </div>
        )}
      </div>
    );
  }
}

export default connect('shouldHighlightOfferError')(PaymodeOffer);



// WEBPACK FOOTER //
// ./components/offers/paymodeOffer/index.js